export const UNITS = {
  acre: "acre",
  bit: "bit",
  byte: "byte",
  celsius: "celsius",
  centimeter: "centimeter",
  day: "day",
  degree: "degree",
  fahrenheit: "fahrenheit",
  "fluid-ounce": "fluid-ounce",
  foot: "foot",
  gallon: "gallon",
  gigabit: "gigabit",
  gigabyte: "gigabyte",
  gram: "gram",
  hectare: "hectare",
  hour: "hour",
  inch: "inch",
  kilobit: "kilobit",
  kilobyte: "kilobyte",
  kilogram: "kilogram",
  kilometer: "kilometer",
  liter: "liter",
  megabit: "megabit",
  megabyte: "megabyte",
  meter: "meter",
  mile: "mile",
  "mile-scandinavian": "mile-scandinavian",
  milliliter: "milliliter",
  millimeter: "millimeter",
  millisecond: "millisecond",
  minute: "minute",
  month: "month",
  ounce: "ounce",
  percent: "percent",
  petabyte: "petabyte",
  pound: "pound",
  second: "second",
  stone: "stone",
  terabit: "terabit",
  terabyte: "terabyte",
  week: "week",
  yard: "yard",
  year: "year",
}

export const STYLE = {
  decimal: "decimal",
  currency: "currency",
  percent: "percent",
  unit: "unit",
}

export const UNIT_DISPLAY = {
  long: "long",
  short: "short",
  narrow: "narrow",
}

export const CURRENCY_DISPLAY = {
  symbol: "symbol",
  code: "code",
  name: "name",
}
